const BrokerRpc = require('./BrokerRpc');
const DaqGatewayClient = require('./DaqGatewayClient');


module.exports = {
    buildDaqGatewayBrokerClient({ brokerClient, gatewayCode, gatewayId, gatewaySite, userName }) {
        gatewayCode = gatewayCode || gatewayId
        const brokerRpc = new BrokerRpc(brokerClient, gatewaySite, gatewayCode, userName);
        return new DaqGatewayClient(brokerRpc);
    }
};
